import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const UnifiedModal = ({
  open,
  onClose,
  title = 'Reject Request',
  description = 'Please provide a reason for rejection:',
  inputLabel = 'Rejection Description',
  inputValue,
  onInputChange,
  cancelLabel = 'Cancel',
  rejectLabel = 'Reject',
  onCancel,
  onReject,
  rejectButtonColor = 'error',
  rejectButtonVariant = 'contained',
  maxWidth = 'xs',
  fullWidth = true,
  minRows = 2,
  autoFocus = true,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography sx={{ mb: 2 }}>{description}</Typography>
      <TextField
        autoFocus={autoFocus}
        margin="dense"
        label={inputLabel}
        type="text"
        fullWidth
        multiline
        minRows={minRows}
        value={inputValue}
        onChange={onInputChange}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="secondary">{cancelLabel}</Button>
      <Button onClick={onReject} color={rejectButtonColor} variant={rejectButtonVariant}>{rejectLabel}</Button>
    </DialogActions>
  </Dialog>
);

export default UnifiedModal;

